import React, { useState } from "react";
import { Box, Fade, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Fab from "@mui/material/Fab";
import Modal from "@mui/material/Modal";
import Collapse from "@mui/material/Collapse";

import NavBar from "../DeedSearch/NavBar";
import { DeedGroup } from "./DeedListDeedGroup";
import { LoadingState } from "./DeedListLoadingState";
import DeedEdit from "../DeedEdit/DeedEdit";
import TrackerCalendar from "../DeedCalendar/DeedCalendar";
import useDeeds from "../../../hooks/useDeeds";
import { useDeedsUI } from "../DeedsUIContext";

const DeedList = () => {
  const { chipValues } = useDeedsUI();
  const { sortedDeeds, groupedDeeds, options, totalCount, isLoading, isProcessing } =
    useDeeds(chipValues);

  const [isEditMode, setIsEditMode] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    setIsEditMode(false);
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <NavBar options={options} />

      <Box my={4} style={{ bgcolor: "background.paper" }}>
        {!isProcessing && (
          <Collapse in={chipValues.length > 0}>
            <Fade in>
              <Box>
                <TrackerCalendar
                  groupedDeeds={groupedDeeds}
                  totalCount={totalCount}
                />
              </Box>
            </Fade>
          </Collapse>
        )}
        {isLoading || !groupedDeeds ? (
          <LoadingState />
        ) : groupedDeeds.length === 0 ? (
          <Typography variant="body1">Click + below!</Typography>
        ) : (
          <Fade in={!isProcessing} timeout={100}>
            <Box>
              {groupedDeeds.map((group) => (
                <DeedGroup
                  key={group.label}
                  group={group}
                  sortedDeeds={sortedDeeds}
                  isEditMode={isEditMode}
                  setIsEditMode={setIsEditMode}
                />
              ))}
            </Box>
          </Fade>
        )}
      </Box>

      <Fab
        color="primary"
        aria-label="add"
        sx={{
          position: "fixed",
          bottom: (theme) => theme.spacing(2),
          right: (theme) => theme.spacing(2),
        }}
        onClick={handleOpen}
      >
        <AddIcon />
      </Fab>
      <Modal open={open} onClose={handleClose}>
        <DeedEdit
          sortedDeeds={sortedDeeds}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          handleClose={handleClose}
        />
      </Modal>
    </>
  );
};

export default DeedList;
